export default __webpack_public_path__ + "static/media/airtel.9f9c90cd.png";